import React, { useState, useEffect } from "react";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import cellCustomActions from "./cellCustomActions.pure";
import { useTranslation } from "react-i18next";
import { profileIconDefault } from "../../../assets/logos/icons";
// import cellDetailSignatureRequest from "./cellDetailSignatureRequest";
import "./gridCustom.css";
import { SimpleLoading } from "..";

const GridCustom = (props) => {
    const {
        skip, //Number pagination {0}
        take, //Number pagination {6}
        dataGrid, //Array information to grid
        titleRow1, //Header first column
        title2Status, //Header second column
        titleRow4, // Header fourth column
        fieldRow1, //Body information row to first column
        field2Status, //Body information row to second column
        fieldSubtitle, //Subtitle first column
        textSubtitle, //Text more subtitle first column
        fieldImg, //Choose image th
        filter, //True to filter grid
        onFilterChange, //Filter function to grid
        onSelectedItem, //Select information item grid
        setShowDetails, //True or false, show detail
        setNameComponentUser, //Name item actions, section
        column2Status, //True to active second column
        columnFour, //True or false to active four column
        iconOneActiveSelected, //Active one button item, True or false if you use value from array
        iconOneActive,
        IconOneActive, //Active section/item actions, fisrt item action
        iconTwoActive,
        IconTwoActive, //Active section/item actions, second item action
        iconTwoActiveSelected, //Active one button item, True or false if you use value from array
        iconThirdActive,
        IconThirdActive, //Active section/item actions, third item action
        IconFourthActive, //Active section/item actions, four item action
        iconFifthActive, //Active section/item actions, fifth item action
        iconTrashActive, // Active trash icon
        labelOneActions, //Label fisrt item action
        labelTwoActions, //Label second item action
        labelTwoActions2, // Label second option text to action column
        labelThirdActions, //Label third item action
        labelFourthActions, //Label fourth item action
        labelFifthActions, //Label fifth item action
        labelTrashActions, //Label trash icon
        tooltipTrashIcon = "Eliminar", // Trash icon tooltip text
        widthHeaderCol2,
        widthHeaderCol4,
        styleCol1, //Class to td (col1) from table, especifies width
        styleCol2, //Class to td (col2) from table, especifies width
        styleCol4, //Class to td (col4) from table, especifies width
        iconAvatar, //True to show avatar image or false to not show
        activeDialog1, //True to function active dialog and false to change page
        btnOpenDialog1, //Function to open dialog in cellAction
        showDialogYesNo, //Value true or false, to dialog
        loading,
        pageable = true,
        minHeight,
        styleGrid,
        fieldRow1Path,
        fieldRowSubtitlePath,
        fieldRow1PathDefault,
        activeDialog2, //Function to open dialog on second btn in cellAction
        btnOpenDialog2, //Function to open dialog on second btn in cellAction
        showDialogYesNo2, //Value true or false, to dialog on second btn
        activeDialogTrash,
        btnOpenDialogTrash,
        showDialogYesNoTrash,
        labelsColumnsNoPadding, //labels no have padding in columns
        widthHeader,
        column2,
        column2Title,
        column2Field,
        column2HeaderClassname,
        column2Classname,
        rowClick,
        handleIconArrow
    } = props;
    const { t } = useTranslation();

    const initialDataState = {
        skip,
        take,
    };
    const [page, setPage] = useState(initialDataState);
    const [selectedItem, setSelectedItem] = useState({});

    const avatarCell = (props) => {
        return (
            <td className={styleCol1}
                onClick={rowClick ? () => handleIconArrow(props.dataItem) : ""}
            >
                <div className={(labelsColumnsNoPadding) ? "gridHLPure-containerAvatar-no-margin" : "gridHLPure-containerAvatar"}>
                    {iconAvatar === true ? (
                        <div className="gridHLPure-imageAvatar">
                            <img
                                alt="profile-img"
                                src={props.dataItem[fieldImg] || profileIconDefault}
                                className="gridHLPure-avatar"
                            />
                        </div>
                    ) : (
                        " "
                    )}
                    <div className={"gridHLPure-containerLabel"}>
                        <span className="gridHLPure-userName">
                            {fieldRow1PathDefault &&
                                props.dataItem[fieldRow1Path][fieldRow1].length === 0
                                ? props.dataItem[fieldRow1Path][fieldRow1PathDefault] || "----"
                                : fieldRow1Path
                                    ? props.dataItem[fieldRow1Path][fieldRow1] || "----"
                                    : props.dataItem[fieldRow1] || "----"}
                        </span>
                        {
                            (textSubtitle || fieldSubtitle) &&
                            <div className="gridHLPure-detailsContainer">
                                <span className="gridHLPure-fieldSubtitle">
                                    {textSubtitle && fieldSubtitle
                                        ? textSubtitle + " " + props.dataItem[fieldSubtitle]
                                        : textSubtitle}
                                    {fieldRowSubtitlePath
                                        ? props.dataItem[fieldRowSubtitlePath][fieldSubtitle]
                                        : fieldSubtitle && !textSubtitle
                                            ? props.dataItem[fieldSubtitle]
                                            : ""}
                                </span>
                            </div>
                        }
                    </div>
                </div>
            </td>
        );
    };

    const gridSignatureRequestPanelStyle = {
        minHeight: minHeight,
        fontFamily: "Quicksand, sans-serif",
        ...styleGrid,
    };

    const columnTwoCell = (props) =>
        <td className={styleCol2}>
            {column2Status ? (
                <div className="gridHLPure-status">
                    <span
                        className={
                            props.dataItem[field2Status]
                                ? "gridHLPure-gridActive"
                                : "gridHLPure-gridInactive"
                        }
                    >
                        {props.dataItem[field2Status] === true ? "Activo" : "Inactivo"}
                    </span>
                </div>
            ) : (
                ""
            )}
        </td>


    const gridColumnNoRecordsStyle = {
        color: "#2C353C",
        fontSize: "16px",
        fontWeight: 550,
        fontFamily: "Quicksand",
    };

    const onPageChange = (event) => {
        setPage(event.page);
    };

    useEffect(() => {
        onSelectedItem(selectedItem);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedItem]);

    useEffect(() => {
        setPage(initialDataState);
    }, [dataGrid]);

    const pagerSettings = {
        info: true,
        buttonCount: 5,
        type: "numeric",
        previousNext: true,
    }

    return loading ? (
        <SimpleLoading />
    ) : (
        <Grid
            className={"gridHLPure"}
            data={dataGrid.slice(page.skip, page.take + page.skip)}
            reorderable
            style={gridSignatureRequestPanelStyle}
            skip={page.skip}
            take={page.take}
            pageable={pageable ? pagerSettings : null}
            total={dataGrid.length}
            onPageChange={onPageChange}
            filter={filter}
            onChangeFilter={onFilterChange}
        >
            <GridColumn
                field={fieldRow1}
                title={titleRow1}
                cell={avatarCell}
                headerClassName={widthHeader}
            />
            {column2 &&
                <GridColumn
                    field={column2Field}
                    title={column2Title}
                    headerClassName={column2HeaderClassname}
                    className={column2Classname}
                />
            }
            {column2Status && (
                <GridColumn
                    field={field2Status}
                    title={title2Status}
                    cell={columnTwoCell}
                    headerClassName={widthHeaderCol2}
                />
            )}
            {columnFour && (
                <GridColumn
                    title={titleRow4}
                    cell={cellCustomActions({
                        setSelectedItem: setSelectedItem,
                        props,
                        iconOneActive,
                        iconTwoActive,
                        iconThirdActive,
                        setShowDetails: setShowDetails,
                        setNameComponentUser: setNameComponentUser,
                        iconOneActiveSelected,
                        IconOneActive,
                        IconTwoActive,
                        iconTwoActiveSelected,
                        IconThirdActive,
                        IconFourthActive,
                        iconFifthActive,
                        iconTrashActive,
                        labelOneActions,
                        labelTwoActions,
                        labelTwoActions2,
                        labelThirdActions,
                        labelFourthActions,
                        labelFifthActions,
                        labelTrashActions,
                        styleCol4,
                        activeDialog1,
                        btnOpenDialog1,
                        showDialogYesNo,
                        activeDialog2,
                        btnOpenDialog2,
                        showDialogYesNo2,
                        tooltipTrashIcon,
                        activeDialogTrash,
                        btnOpenDialogTrash,
                        showDialogYesNoTrash,
                    })}
                    headerClassName={widthHeaderCol4}
                />
            )}
            <GridNoRecords>
                <span style={gridColumnNoRecordsStyle}>
                    {t("configurationDomainPanel.notResults")}
                </span>
            </GridNoRecords>
        </Grid>
    );
};
export { GridCustom as default };
